import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
  item: {
    flex: '1 1 auto',
  },
  paper: {
    padding: theme.spacing(3),
    height: '100%',
    backgroundColor: 'inherit',
  },
}));

export default function GridInfoText(props) {
  const { name, value } = props;
  const classes = useStyles();

  return (
    <Grid item sm className={classes.item}>
      <TextField
        className={classes.textField}
        label={name}
        name={name}
        value={value}
        variant="outlined"
        fullWidth
        InputProps={{
          readOnly: true,
        }}
      />
    </Grid>
  );
}

GridInfoText.defaultProps = {
  name: '',
  value: '',
};

GridInfoText.propTypes = {
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};
